/* eslint-env browser */

let share
let father
let rootShare
let fbBtn
let listener
let disables

const eventListener = () => {
  if (!listener) {
    rootShare = share.parentNode.parentNode
    rootShare.addEventListener('mouseleave', killShare, false) // eslint-disable-line no-use-before-define

    fbBtn = rootShare.querySelector('.facebook')
    fbBtn.addEventListener('click', fb, false) // eslint-disable-line no-undef

    listener = true
  } else {
    rootShare.removeEventListener('mouseleave', killShare) // eslint-disable-line no-use-before-define
    fbBtn.removeEventListener('click', fb) // eslint-disable-line no-undef
    listener = false
  }
}

const toggleShare = function (e = window.event) { // eslint-disable-line no-unused-vars
  if (e.target.classList.contains('share')) {
    share = e.target
    e.preventDefault()
  }

  fastdom.mutate(() => {
    share.classList.toggle('--open')
  })

  father = share.parentNode

  fastdom.mutate(() => {
    if (share.classList.contains('--open')) {
      father.style.zIndex = 99
    } else {
      father.removeAttribute('style')
    }
  })

  const fatherClass = father.classList[0]
  disables = father.querySelectorAll(`.${fatherClass} > .--btn-foto:not(.share)`)

  fastdom.mutate(() => {
    for (let i = 0; i < disables.length; i++) {
      const item = disables[i]

      item.classList.toggle('--disable')
    }
  })


  eventListener()
}

const killShare = function () {
  fastdom.mutate(() => {
    share.classList.remove('--open')

    father.removeAttribute('style')

    for (let i = 0; i < disables.length; i++) {
      const item = disables[i]
      item.classList.remove('--disable')
    }
  })

  eventListener()
}
